import * as fromRoot from "../../../app/store/state";
import { ActionReducerMap } from "@ngrx/store";
import { State } from "./permissions.state";
import { reducer } from "./permissions.reducers";


export interface PermissionsState extends fromRoot.State
{
  Permissions: State;
}

export const reducers: Partial<ActionReducerMap<PermissionsState>> = {
  Permissions : reducer
};
